declare global {
  interface Window {
    iframeContext?: {
      ref: any;
    };
  }
}

export const postMessageToParent = (message: any) => {
  window.parent.postMessage(message, '*');
};

export const updateIframeHeight = (elemRef?: any) => {
  const elm = elemRef?.base || window.iframeContext?.ref?.base;

  if (elm) {
    const height = elm.offsetHeight;
    postMessageToParent({
      action: 'zoolife:contentHeight',
      height,
    });
    /** @deprecated, but kept it since our partners may still be using it */
    postMessageToParent({
      action: 'contentHeight',
      height,
      /** @deprecated, but kept it since our partners may still be using it */
      setHeight: height,
    });
  }
};

export default updateIframeHeight;
